<template>
  <section class="mapContent posire">
    <baidu-map
        class="map"
        :scroll-wheel-zoom="true"
        :center="center"
        :zoom="zoom"
        @ready="renderMap"
        @click="handleMapClick"
        :map-click="false"
    >
      <bm-view class="map" />
      <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
      />
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
<!--      <bm-driving-->
<!--          start="新疆"-->
<!--          end="北京"-->
<!--          :auto-viewport="true"-->
<!--          :policy="policy"-->
<!--          :panel="false"-->
<!--          @searchcomplete="pathSearchcomplete"-->
<!--      >-->
<!--      </bm-driving>-->

    </baidu-map>
  </section>
</template>

<script>
export default {
  data () {
    return {
      // 搜索结果数组
      searchResultList: [],
      currentSelectTitle: '',
      listVisible: false,
      searchTimer: null,
      searchAddr: '',
      BMap: null,
      map: null,
      dialogVisible: false,
      center: { lng: 0, lat: 0 },
      zoom: 3,
      pointDescVisible: false,
      markerPoint: null,
      markerPointAddress: '',

      policy: null, // 驾车方案的策略配置
      start: '', // 路径起点
      end: '', // 路径终点
    };
  },
  methods: {
    renderMap ({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      // this.markerPoint = this.center;
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
    },
    // e 是 经纬度
    handleMapClick (e) {
      if (e && e.point) {
        this.markerPoint = e.point;
        this.getAddress();
      }
    },
    pathTypeChange (pathOrigin, pathEndPoint, pathType) {
      const policy = [
        BMAP_DRIVING_POLICY_AVOID_HIGHWAYS, // 费用最少
        BMAP_DRIVING_POLICY_LEAST_TIME, // 时间最短
        BMAP_DRIVING_POLICY_LEAST_DISTANCE, // 距离最短
      ];

      this.policy = policy[pathType];
      this.start = pathOrigin;
      this.end = pathEndPoint;
      this.drawRoute();

    },
    drawRoute () {
      let _this = this;
      this.map.clearOverlays(); // 先清除掉地图的覆盖物
      // 创建地址解析器实例
      var myGeo = new BMap.Geocoder();
      let startPoint = null;
      let endPoint = null;
      // 将地址解析结果显示在地图上,并调整地图视野
      myGeo.getPoint(this.start, function (point) {
        if (point) {
          startPoint = {lng: point.lng, lat: point.lat};
          console.log('startPoint', startPoint);
          _this.$emit('startPoint', startPoint);
        }
      }, this.start);

      myGeo.getPoint(this.end, function (point) {
        if (point) {
          endPoint = {lng: point.lng, lat: point.lat};
          console.log('endPoint', endPoint);
          _this.$emit('endPoint', endPoint);
        }
      }, this.end);
      setTimeout(() => {
        if (!startPoint) {
          _this.$emit('startPoint');
        }
        if (!endPoint) {
          _this.$emit('endPoint');
        }
        if (startPoint && endPoint) {
          var pp1 = new this.BMap.Point(startPoint.lng, startPoint.lat);
          var pp2 = new this.BMap.Point(endPoint.lng, endPoint.lat);
          var driving1 = new this.BMap.DrivingRoute(this.map,
            {
              renderOptions: {
                map: this.map,
                autoViewport: true,
              },
              policy: this.policy,
            });
          driving1.search(pp1, pp2);
          var driving = new this.BMap.DrivingRoute(this.map,
            {
              onSearchComplete: function (results) {
                if (driving.getStatus() == BMAP_STATUS_SUCCESS) {
                  var plan = results.getPlan(0);
                  const time = plan.getDuration(true); // 获取时间
                  const distance = plan.getDistance(true); // 获取距离

                  const startInfo = results.getStart().point; // 获取起点经纬度
                  const endInfo = results.getEnd().point; // 获取终点经纬度

                  const step = plan.getRoute(0).getPath(); // 获取路线所有点的经纬度
                  var steps = step.length > 1000 ? Math.floor(step.length / 1000) : 1; // 控制只给后端传1000个点的经纬度信息
                  let content = [];
                  for (var i = 0; i < step.length; i += steps) {
                    content.push({
                      lng: step[i].lng,
                      lat: step[i].lat,
                    });
                  }
                  // console.log('时间',time)
                  // console.log('距离',distance)
                  // console.log('起点经纬度', startInfo);
                  // console.log('终点经纬度', endInfo);
                  // console.log('路线的点',content)
                  _this.$emit('distanceDetail', time, distance, content, startInfo, endInfo);
                }
              },
            },
            {
              renderOptions: {
                map: this.map,
                autoViewport: true,
              },
              policy: this.policy,
            });
          driving.search(pp1, pp2);
        } else {
          _this.$emit('distanceDetail');
        }
      }, 1000);
    },

  },
};
</script>

<style scoped lang="scss">
.searchList {
  width: 240px;
  position: absolute;
  top: 55px;
  left: 20px;
}
.searchMapInputBox {
  padding: 20px;
  .searchInput {
    width: 400px;
    margin-right: 16px;
  }
}
.mapContent {
  //padding-bottom: 32px;
  .map {
    width: 100%;
    height: 821px;
  }
  .searchList {
    ::v-deep ol {
      height: 474px;
      overflow-y: auto;
    }
  }
}
.hadKeywordList {
  padding-left: 264px;
}

.BMap_noprint anchorTL{
  inset: 30px auto auto 450px!important;
}
</style>
